import GameMap   from "./GameMap"
import Loader    from "./Loader"
import BaseError from "./errors/BaseError"

class MapLoader {

  /*
   * window - The global window object - passed to avoid this class depending directly on global state
   * forceNoCache - If true, will try its best to request the resource without caching. Useful for dev.
   * log - the global log object
   */
  constructor({ log, window, worldId, forceNoCache, forceSlowNetwork }) {
    this.log     = log.forClass("MapLoader")
    this.worldId = worldId
    this.loader  = new Loader({ window: window, forceNoCache: forceNoCache, log: this.log, forceSlowNetwork: forceSlowNetwork })
    this.window  = window
  }

  /*
   * Loads a given map from the given world with the given traveler name.
   *
   * mapName: The name of the map in this world to try to load
   * travelerName: The name of the travceler to use once the map is loaded. If omitted, will
   * use the map's configured traveler. Note that if specified, travelerName must be allowed by
   * the map.
   *
   * Returns a promise that yields the JSON fo the map object loaded by this method.
   *
   * Will reject if the map could not be loaded. See Loader for the rejection forms.
   */
  loadMap({ mapName, travelerName }) {
    const logger = this.log.method("loadMap", { mapName, travelerName })
    return this.loader.load(`/worlds/${this.worldId}/maps/${mapName}.json`).then( (mapJSON) => {
      const map = new GameMap(mapJSON.map)
      if (travelerName) {
        logger.addDetails({ newTravelerName: travelerName })
        map.changeTraveler(travelerName)
      }
      logger.end()
      return Promise.resolve(map)
    }).catch( (error) => {
      return Promise.reject(BaseError.wrap(error, `loading map '${mapName}'`, (wrappedError) => {
        logger.end(wrappedError.loggingDetails())
      }))
    })
  }
}

export default MapLoader
